import { Button, Stack, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import AppBarRoot from "./Root";
import AppBarMenu from "./Menu";
import { NaturePeople, Share } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScheduleService from "../ScheduleService";
import IconCompanyLogo from "../Icon/CompayLogo";
import { getAuth } from "firebase/auth";

function AppBarMyGarden({ isMyGarden, clientUuid, clientName, siteUuid }) {
  const navigate = useNavigateToTop();

  let currentUser = getAuth().currentUser;

  const navigateToWebsite = () => {
    window.location.href = `https://www.birkettgardens.com.au`;
  };

  return (
    <AppBarRoot
      startAction={
        <Stack direction={"row"} spacing={2}>
          {currentUser && <AppBarMenu />}
          {isMyGarden && (
            <Fragment>
              <Typography
                onClick={() => navigate("/")}
                variant="h5"
                style={{ alignSelf: "center", color: "white" }}
              >
                {isMyGarden
                  ? "My Garden"
                  : clientName
                  ? `${clientName}'s`
                  : "Garden"}
              </Typography>
            </Fragment>
          )}
          {!isMyGarden && !currentUser && (
            <IconCompanyLogo
              onClick={navigateToWebsite}
              style={{ height: "3rem", padding: "1rem 0rem" }}
            />
          )}
        </Stack>
      }
      endAction={
        <Stack direction={"row"} spacing={1}>
          {/* <Button
            startIcon={<CalendarMonthIcon />}
            variant="contained"
            onClick={onShceduleClicked}
          >
            Schedule
          </Button> */}
          {isMyGarden && (
            <ScheduleService
              clientUuid={clientUuid}
              clientName={clientName}
              siteUuid={siteUuid}
            />
          )}
          {!isMyGarden && !currentUser && (
            <Button
              startIcon={<NaturePeople />}
              variant="contained"
              color="secondary"
              onClick={navigateToWebsite}
              style={{
                height: "fit-content",
                alignSelf: "center",
              }}
            >
              Who made this?
            </Button>
          )}
        </Stack>
      }
    />
  );
}

export default AppBarMyGarden;
